<ng-container>
  <div class="field-container">
    <div class="label-container">
      <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
      <span *ngIf="maxLength" class="char-counter" [ngClass]="isMaxLengthExceeded ? 'text-danger' : 'text-muted'">
        {{characterCount}}/{{maxLength}}
      </span>
    </div>
    <textarea [ngModel]="value" pSize="small" [rows]="rows" cols="30" pTextarea [autoResize]="autoResize" class="w-full"
      appendTo="body" [disabled]="disabled" autocomplete="off" (ngModelChange)="changeText($event)"
      (focus)="selectAllText($event)"></textarea>
  </div>
</ng-container>